module.exports = __webpack_public_path__ + "static/media/glimpse_logo_w_text_white.e7ee42bd.svg";